import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Share2, Wand2 } from "lucide-react";
import WizardCatalogoDialog from "@/components/WizardCatalogoDialog";

/**
 * Tarjeta compartible: URL del catálogo público del usuario actual
 * + un único botón "Personalizar y compartir" que abre el wizard.
 *
 * Oct/2026: simplificado. Antes incluía Copiar / WhatsApp / Ver y un
 * dropdown de categorías inline — todo eso quedó duplicado con el wizard
 * (que ya ofrece link personalizado + copiar + whatsapp + ver + PDF).
 */
export default function CompartirCatalogoCard({ variant = "default" }) {
  const [link, setLink] = useState(null);
  const [wizardOpen, setWizardOpen] = useState(false);

  useEffect(() => {
    api.get("/me/catalogo-link").then((r) => setLink(r.data)).catch(() => setLink(null));
  }, []);

  if (!link) return null;

  const basePath = link.path;
  const fullUrl = `${window.location.origin}${basePath}`;
  const rounded = variant === "director" ? "rounded-2xl" : "rounded-3xl";

  return (
    <div className={`bg-gradient-to-br from-pink-50 via-white to-pink-50 border-2 border-pink-200 ${rounded} p-4 md:p-6`} data-testid="compartir-catalogo-card">
      {/* Header: icono + títulos (mobile-first, siempre apilado para que no
          se rompa en modales angostos). */}
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 md:w-11 md:h-11 rounded-2xl bg-primary text-white flex items-center justify-center flex-shrink-0">
          <Share2 className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-primary">Comparte con tus clientes</div>
          <h3 className="font-display text-lg font-semibold text-foreground mt-0.5">Tu catálogo en vivo</h3>
          <p className="text-xs text-muted-foreground mt-1">
            Sin cantidades exactas ni precios por defecto. Personaliza qué ve cada cliente desde el botón.
          </p>
        </div>
      </div>

      {/* URL compacta: full-width, monoespaciada, wrappea solo si falta ancho */}
      <div className="mt-3 bg-white/80 border border-pink-200 rounded-md px-2.5 py-1.5 text-[11px] font-mono text-slate-600 break-all" data-testid="compartir-url">
        {fullUrl}
      </div>

      {/* Un único CTA que lanza el wizard de personalización */}
      <button
        onClick={() => setWizardOpen(true)}
        className="mt-3 w-full md:w-auto h-10 px-5 rounded-lg bg-primary hover:bg-primary/90 text-white font-semibold text-sm flex items-center justify-center gap-2 shadow-sm"
        data-testid="wizard-personalizar-btn"
      >
        <Wand2 className="w-4 h-4" /> Personalizar y compartir
      </button>

      <WizardCatalogoDialog open={wizardOpen} onOpenChange={setWizardOpen} />
    </div>
  );
}
